import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import InvitationPage from '../components/invitations/InvitationPage';
import { fetchInvitation, acceptInvitation, deleteInvitation } from '../actions/invitations';
import { compose } from 'redux';
import { withCurrentUser } from './withUser';
import { withNavigation } from '../actions/navigation';

/**
 * Invitation page, allowing users to accept or deny invitations
 * Takes invitation ID from URL param
 * Any user can access it, as long as he has the invitation ID and token ID
 */

const mapStateToProps = (state, { invitationId }) => {
  const {
    invitationsById
  } = state;
  return {
    invitation: invitationsById[invitationId]
  };
}

const mapDispatchToProps = (dispatch, { 
  invitationId, 
  invitationToken, 
  navigateToHomepage, 
  navigateBackToProduct,
  user
}) => {
  
  return {
    loadData: _ => dispatch(fetchInvitation(invitationId, invitationToken)),
    handleAccept: () => 
      dispatch(acceptInvitation(invitationId, invitationToken, user.id))
        .then(res => {
          if( res && res.licence && res.licence.plan && res.licence.plan.product ) {
            navigateBackToProduct(res.licence.plan.product);
          } else {
            navigateToHomepage();
          }
        }),
    handleDeny: () => 
      dispatch(deleteInvitation(invitationId, invitationToken))
        .then(navigateToHomepage)
  }
}

const Container = compose(
  withCurrentUser,
  withNavigation,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(
  InvitationPage
);

Container.propTypes = {
  invitationId: PropTypes.string.isRequired,
  invitationToken: PropTypes.string.isRequired,
};

export default Container;


// WEBPACK FOOTER //
// ./src/containers/InvitationPage.js